import React, { useContext, useState } from "react"
import { FormattedMessage } from "react-intl"
import { Box, DialogContentText, DialogTitle, Typography } from "@carrotfertility/carotene-core"
import { Form } from "@carrotfertility/carotene-core-x"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { HttpErrors } from "#/utils/HttpErrors"
import { RequestCardContext } from "#/pages/request-carrot-card-flow"
import RequestCardWrapper from "#/pages/request-carrot-card-flow/requestCardWrapper"
import { unexpectedServerErrorAlert } from "#/pages/request-carrot-card-flow/requestCardWrapper/unexpected-error-alert"
import { invalidAddressErrorAlert } from "#/pages/request-carrot-card-flow/requestCardWrapper/invalid-address-error-alert"
import { Steps } from "#/pages/request-carrot-card-flow/workflows/steps"
import { useRequestCarrotCard } from "../AirwallexUserAgreement/request-carrot-card"
import { attemptRequest } from "../AirwallexUserAgreement/agreement-helpers"
import { useNameOnCard } from "./use-name-on-card"

export function CardholderNameReview() {
  const { send } = useStateMachine()
  const { shouldSeeUserAgreement } = useContext(RequestCardContext)
  const { data: nameOnCard } = useNameOnCard()
  const [isAddressError, setIsAddressError] = useState(false)
  const requestCardMutation = useRequestCarrotCard({
    onSuccess: () => send(""),
    onError: (error) => {
      if (error.name === HttpErrors.BAD_REQUEST && error.message.includes("postal_address")) {
        setIsAddressError(true)
      } else {
        setIsAddressError(false)
      }
    }
  })

  const determineErrorToDisplay = () => {
    if (!requestCardMutation.isError) return null
    return isAddressError ? invalidAddressErrorAlert : unexpectedServerErrorAlert
  }

  return (
    <Form onSubmit={() => attemptRequest(requestCardMutation.mutateAsync)}>
      <RequestCardWrapper
        // Without a user agreement, the previous step requests the card on load, so skip past it
        goBackToStepName={shouldSeeUserAgreement ? Steps.AIRWALLEX_USER_AGREEMENT : Steps.CONFIRM_PHONE_NUMBER}
        showBackButton
        showContinueButton
      >
        <DialogTitle>
          <FormattedMessage defaultMessage="Character limitations" />
        </DialogTitle>
        <DialogContentText sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.md }}>
          <FormattedMessage defaultMessage="Our card issuer only supports English-language characters for cardholder names, so the name we share with them will look different from your Carrot account settings." />
        </DialogContentText>
        <DialogContentText sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.xl }}>
          <FormattedMessage defaultMessage="This doesn't change the name we have on file for you." />
        </DialogContentText>
        <Box sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.xl }}>
          <Typography variant="h6" component="h3">
            <FormattedMessage defaultMessage="Name as it will appear on the card" />
          </Typography>
          <Typography variant="body1">{nameOnCard?.nameOnCard}</Typography>
        </Box>
        {determineErrorToDisplay()}
      </RequestCardWrapper>
    </Form>
  )
}
